import Swiper from "swiper";
import { Autoplay, Pagination, Navigation, EffectFade, EffectCreative, Keyboard, Mousewheel, Thumbs } from "swiper/modules";
/**
 * @param swiperInit
 */
export function swiperInit() {
	new Swiper(".section-home-banner .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		loop: true,
		effect: "fade",
		autoplay: {
			delay: 3500,
		},
		modules: [Pagination, Navigation, Autoplay, EffectFade],
		pagination: {
			el: ".section-home-banner .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-home-banner .btn-next",
			prevEl: ".section-home-banner .btn-prev",
		},
	});
	// Reuseable Swiper
	$(".swiper-cols-1 .swiper").each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation],
			navigation: {
				nextEl: $(this).closest(".swiper-cols-1").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-1").find(".btn-prev")[0],
			},
		});
	});
	$(".swiper-cols-2 .swiper").each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation],
			navigation: {
				nextEl: $(this).closest(".swiper-cols-1").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-1").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		});
	});
	$(".swiper-cols-3 .swiper").each(function () {
		const config = {
			slidesPerView_sm: this.getAttribute("swiper-sm-slides") || 1,
			slidesPerView_md: this.getAttribute("swiper-md-slides") || 2,
			slidesPerView_lg: this.getAttribute("swiper-lg-slides") || 3,
			slidesPerView_xl: this.getAttribute("swiper-xl-slides") || 3,
			spaceBetween_sm: this.getAttribute("swiper-sm-padding") || 15,
			spaceBetween_md: this.getAttribute("swiper-md-padding") || 15,
			spaceBetween_lg: this.getAttribute("swiper-lg-padding") || 40,
			spaceBetween_xl: this.getAttribute("swiper-xl-padding") || 40,
		};
		new Swiper(this, {
			slidesPerView: config.slidesPerView_sm,
			spaceBetween: config.spaceBetween_sm,
			modules: [Navigation, Pagination],
			speed: 1000,
			navigation: {
				nextEl: $(this).closest(".swiper-cols-3").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-3").find(".btn-prev")[0],
			},
			pagination: {
				el: $(this).closest(".swiper-cols-3").find(".swiper-pagination")[0],
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: config.slidesPerView_md,
					spaceBetween: config.spaceBetween_md,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: config.spaceBetween_lg,
				},
				1200: {
					slidesPerView: config.slidesPerView_xl,
					spaceBetween: config.spaceBetween_xl,
				},
			},
		});
	});
	$(".swiper-cols-4 .swiper").each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation],
			navigation: {
				nextEl: $(this).closest(".swiper-cols-4").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-4").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
			},
		});
	});
	new Swiper(".section-home-testimonials .swiper", {
		slidesPerView: 1.2,
		spaceBetween: 15,
		centeredSlides: true,
		loop: true,
		modules: [Pagination, Autoplay],
		autoplay: {
			delay: 3500,
			pauseOnMouseEnter: true,
			disableOnInteraction: true,
		},
		pagination: {
			el: ".section-home-testimonials .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 1.6,
				spaceBetween: 15,
			},
			1024: {
				slidesPerView: 2.2,
				spaceBetween: 40,
			},
			1200: {
				slidesPerView: 2.6,
				spaceBetween: 40,
			},
		},
	});
}

var timerShowPagination;
export const Fullpage = {
	generateThumbs: function () {
		const countSlide = jQuery(".fullpage-swiper > .swiper > .swiper-wrapper > .swiper-slide").length;
		jQuery(".fullpage-swiper > .swiper > .swiper-wrapper > .swiper-slide").each(function (index) {
			let title = $(this).data("title");
			jQuery(".fullpage-slide-thumb .swiper-wrapper").append(`<div class="swiper-slide"><div class="item-thumb"><p>${title || ""}</p><span>0${index + 1}</span></div></div>`);
		});
	},
	swiper: function () {
		var fullpage_thumb = new Swiper(".fullpage-slide-thumb .swiper", {
			direction: "vertical",
			speed: 800,
			allowTouchMove: false,
			observer: true,
			spaceBetween: 12,
			observeParents: true,
		});
		var fullpage_main = new Swiper(".fullpage-swiper .swiper-full-current", {
			spaceBetween: 0,
			direction: "vertical",
			speed: 1000,
			observer: true,
			observeParents: true,
			modules: [Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs],
			mousewheel: {
				forceToAxis: true,
				thresholdTime: 1200,
			},
			thumbs: {
				swiper: fullpage_thumb,
			},
			keyboard: {
				enabled: true,
			},
			freeMode: false,
			slidesPerView: 1,
			allowTouchMove: false,
			effect: "creative",
			creativeEffect: {
				prev: {
					shadow: true,
					translate: [0, "-100%", -1],
				},
				next: {
					translate: [0, "100%", 0],
				},
			},
			on: {
				transitionEnd: async () => {
					const color = $(".swiper-full-current > .swiper-wrapper > .swiper-slide-active .section-swiper").data("color");
					console.log("🚀 ~ transitionEnd: ~ color:", color);
					if (color == "primary") {
						$(".fullpage-slide-thumb").addClass("color-primary");
					} else {
						$(".fullpage-slide-thumb").removeClass("color-primary");
					}
				},
				init: async () => {
					const sleep = (t) => new Promise((r) => setTimeout(r, t));
					await sleep(1000);
					jQuery("header").addClass("header-black");
					$(".fullpage-slide-thumb").addClass("active");
				},
				afterInit: async (swiper) => {
					const number = window.location.hash.replace("#", "");
					if (number) {
						const lastNumber = number.split("-")[1];
						swiper.slideTo(lastNumber - 1);
					}
				},
			},
		});
		// How to catch url hash change when click button, all element have attribute data-hash
		$(".section-home-banner a").on("click", function () {
			const hash = this.hash.substr(1);
			if (hash) {
				const number = hash.replace("#", "");
				const lastNumber = number.split("-")[1];
				fullpage_main.slideTo(lastNumber - 1);
				return false;
			} else {
				return true;
			}
		});

		$(".button-to-top").on("click", function () {
			fullpage_main.slideTo(0);
		});
	},

	init: function () {
		if (window.matchMedia("(min-width: 1200px)").matches) {
			Fullpage.generateThumbs();
			Fullpage.swiper();
		}
	},
};
